import clsx from "clsx";
import { useEffect } from "react";
import type { ReactNode } from "react";

import {
	getMobileP3FeedbackPlan,
	triggerMobileP3Haptic,
	type MobileP3EventKind,
} from "../util/mobileP3Enhancements.ts";

type MobileP3EventFeedbackProps = {
	active?: boolean;
	children?: ReactNode;
	className?: string;
	event: MobileP3EventKind;
};

export const MobileP3EventFeedback = ({
	active = true,
	children,
	className,
	event,
}: MobileP3EventFeedbackProps) => {
	const plan = getMobileP3FeedbackPlan({
		event,
	});
	const hapticPattern = plan.hapticPattern;
	const hapticPatternKey = hapticPattern?.join("-") ?? "none";

	useEffect(() => {
		if (!active) {
			return;
		}

		triggerMobileP3Haptic(
			typeof navigator === "undefined" ? undefined : navigator,
			hapticPattern,
		);
	}, [active, event, hapticPatternKey]);

	if (!active) {
		return null;
	}

	return (
		<span
			aria-live="polite"
			className={clsx(
				"mobile-p3-event-feedback",
				plan.animationEnabled
					? "mobile-p3-event-feedback-motion"
					: "mobile-p3-event-feedback-static",
				className,
			)}
			role="status"
		>
			{children ?? plan.statusText}
		</span>
	);
};

export default MobileP3EventFeedback;
